import {
  type RailItem,
  isInterruption,
} from '@/components/InterruptionTile/types';
import type { Ga4Item, ListIdentity } from '@/types';
import { toGa4Item } from '@/utils/toGa4Item';

export interface ChartListSourceData {
  contentId?: number;
  listName?: string;
}

/**
 * Builds the GA4 list identity for a chart page. Shared by `ChartProductList`
 * (Grid view) and `ChartListTracker` (List view) so the two surfaces cannot
 * drift — before this extraction every chart page reported the same
 * hardcoded `'chart-product-list'` name regardless of which page it was.
 */
export const buildChartListIdentity = (
  data: ChartListSourceData,
): ListIdentity => ({
  name: data.listName || 'chart-product-list',
  id: data.contentId ? String(data.contentId) : undefined,
});

/**
 * Maps chart items to `Ga4Item`s, skipping interruption cells (they are not
 * products and have no GA4 representation) and numbering the remaining items
 * from `offset`.
 */
export const buildChartGa4Items = (
  items: RailItem[],
  list: ListIdentity,
  offset: number,
): Ga4Item[] =>
  items
    .map((item, i) =>
      isInterruption(item) ? null : toGa4Item(item, list, offset + i),
    )
    .filter((item): item is Ga4Item => item !== null);
